var map = {
	"./turntable-btn.png": 71948,
	"./turntable-btn1.png": 57247,
	"./turntable-btn2.png": 27332,
	"./turntable-btn3.png": 69837,
	"./turntable-btn4.png": 88274,
	"./turntable-btn4_disable.png": 43275,
	"./turntable-btn5.png": 37275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12579;